import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Typography from "@material-ui/core/Typography";

import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import KeyValueText from "../../components/display/KeyValueText";
import ComponentLoader from "../../components/loader/ComponentLoader";
import StatusChip from "../../components/chips/StatusChip";
import { updateCategoryList } from "../../store/actions/appdata";

import AddEditCatForm from "../../components/category/AddEditCatForm";
import DeleteCatForm from "../../components/category/DeleteCatForm";
import AddEditSubCatForm from "../../components/category/AddEditSubCatForm";
import DeleteSubCatForm from "../../components/category/DeleteSubCatForm";

import pageTitle from "../../utils/pageTitle";
import { permissions, types, checkAcl } from "../../utils/acl";

const useStyles = makeStyles(theme => ({
  avatar: {
    marginRight: 10,
    width: 27,
    height: 27,
    fontSize: 15,
    fontWeight: "bold",
    color: "#fff"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  paper: {
    width: "100%",
    overflowX: "auto",
    marginBottom: theme.spacing(2),
    backgroundColor: "#212121",
    padding: "15px"
  }
}));

const initialParams = {
  action: "add",
  initialValues: {
    name: "",
    desc: "",
    color: "",
    seq: "",
    icon: "",
    status: 1
  },
  catId: 0
};

const initialParamsSub = {
  action: "add",
  initialValues: {
    name: "",
    seq: "",
    icon: "",
    status: 1
  },
  catId: 0,
  subCatId: 0
};

export default function CategoryList() {
  const dispatch = useDispatch();
  const categoryList = useSelector(state =>
    !!state.appdata.category.list
      ? state.appdata.category.list.sort((a, b) => a.seq > b.seq)
      : []
  );

  const EDIT_ACCESS = checkAcl({ p: permissions.CATEGORY_MANAGEMENT, t: types.VIEW_AND_EDIT });
  const DELETE_ACCESS = checkAcl({ p: permissions.CATEGORY_MANAGEMENT, t: types.VIEW_EDIT_AND_DELETE });

  const classes = useStyles();
  const [isLoading, setIsloading] = useState(true);

  useEffect(() => {
    pageTitle("Categories");
  }, []);

  useEffect(() => {
    if (categoryList.length === 0) {
      setIsloading(true);
      dispatch(updateCategoryList());
    } else {
      setIsloading(false);
    }
  }, [categoryList, dispatch]);

  //Expansion Panel
  const [expanded, setExpanded] = useState(false);
  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  //Add Edit Category
  const [addEditParams, setAddEditParams] = useState(initialParams);
  const [openCatModal, setOpenCatModal] = useState(false);

  function handleOpenCatModal() {
    setOpenCatModal(true);
  }

  function handleCloseCatModal() {
    setOpenCatModal(false);
  }

  const addButtonClick = () => {
    setAddEditParams(initialParams);
    handleOpenCatModal();
  };

  const editButtonClick = cat => {
    setAddEditParams({
      action: "edit",
      initialValues: {
        name: cat.name,
        desc: !!cat.desc ? cat.desc : "",
        color: cat.color,
        seq: cat.seq,
        icon: !!cat.icon ? cat.icon : "",
        status: cat.status
      },
      catId: cat.id
    });
    handleOpenCatModal();
  };

  //Delete Category
  const [deleteParams, setDeleteParams] = useState({
    catId: null,
    catName: null
  });
  const [openCatDeleteModal, setOpenCatDeleteModal] = useState(false);

  function handleOpenCatDeleteModal() {
    setOpenCatDeleteModal(true);
  }

  function handleCloseCatDeleteModal() {
    setOpenCatDeleteModal(false);
  }
  const deleteButtonClick = cat => {
    setDeleteParams({
      catName: cat.name,
      catId: cat.id
    });
    handleOpenCatDeleteModal();
  };

  //Add Edit Sub Category
  const [addEditParamsSub, setAddEditParamsSub] = useState(initialParamsSub);
  const [openSubCatModal, setOpenSubCatModal] = useState(false);

  function handleOpenSubCatModal() {
    setOpenSubCatModal(true);
  }

  function handleCloseSubCatModal() {
    setOpenSubCatModal(false);
  }

  const addSubcatButtonClick = catId => {
    setAddEditParamsSub({
      ...initialParams,
      catId: catId
    });
    handleOpenSubCatModal();
  };

  const editSubcatButtonClick = subCat => {
    setAddEditParamsSub({
      action: "edit",
      initialValues: {
        name: subCat.name,
        seq: subCat.seq,
        icon: !!subCat.icon ? subCat.icon : "",
        status: subCat.status
      },
      catId: subCat.cat,
      subCatId: subCat.id
    });
    handleOpenSubCatModal();
  };

  //Delete Sub Category
  const [deleteParamsSub, setDeleteParamsSub] = useState({
    catId: null,
    subCatId: null,
    subCatName: null
  });
  const [openSubCatDeleteModal, setOpenSubCatDeleteModal] = useState(false);

  function handleOpenSubCatDeleteModal() {
    setOpenSubCatDeleteModal(true);
  }

  function handleCloseSubCatDeleteModal() {
    setOpenSubCatDeleteModal(false);
  }
  const deleteSubcatButtonClick = subCat => {
    setDeleteParamsSub({
      catId: subCat.cat,
      subCatId: subCat.id,
      subCatName: subCat.name
    });

    handleOpenSubCatDeleteModal();
  };

  return (
    <Container style={{ padding: "10px" }}>
      <h3>Categories</h3>
      <ComponentLoader isLoading={isLoading} />
      {categoryList.map(cat => {
        return (
          <Accordion
            expanded={expanded === `panel${cat.id}`}
            onChange={handleChange(`panel${cat.id}`)}
            key={cat.id}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${cat.id}-content`}
              id={`panel${cat.id}-header`}
            >
              <Avatar
                className={classes.avatar}
                style={{ backgroundColor: `${cat.color || "#3B3B3B"}` }}
              >
                {cat.name.substring(0, 1).toUpperCase()}
              </Avatar>
              <Typography className={classes.heading}>{cat.name}</Typography>
              <Typography className={classes.secondaryHeading}>
                {cat.desc}
              </Typography>
              {expanded === `panel${cat.id}` && cat.id !== 1 &&
                <Box style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                  <Box display="flex" flexWrap="no-wrap">
                    {EDIT_ACCESS &&
                      <IconButton
                        className={classes.button}
                        aria-label="edit-correction"
                        onClick={() => editButtonClick(cat)}
                        size="small"
                      >
                        <EditIcon />
                      </IconButton>}
                    {DELETE_ACCESS &&
                      <IconButton
                        className={classes.button}
                        aria-label="delete-correction"
                        onClick={() => deleteButtonClick(cat)}
                        size="small"
                      >
                        <DeleteIcon />
                      </IconButton>}
                  </Box>
                </Box>}
            </AccordionSummary>
            <AccordionDetails>
              <Paper className={classes.paper}>
                <KeyValueText
                  keyName="Sequence"
                  color="textPrimary"
                  value={cat.seq || " "}
                />
                <KeyValueText
                  keyName="Description"
                  color="textPrimary"
                  value={cat.desc || " "}
                />
                <KeyValueText
                  keyName="Color"
                  color="textPrimary"
                  value={cat.color || " "}
                />
                <KeyValueText
                  keyName="Icon"
                  color="textPrimary"
                  value={cat.icon || " "}
                />
                <StatusChip status={cat.status} />
                {/* {cat.id !== 1 && (
                  <Box display="flex" flexWrap="no-wrap">
                    <IconButton
                      className={classes.button}
                      aria-label="edit-correction"
                      onClick={() => editButtonClick(cat)}
                      size="small"
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      className={classes.button}
                      aria-label="delete-correction"
                      onClick={() => deleteButtonClick(cat)}
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                )} */}
                <br />
                <Typography variant="subtitle2" gutterBottom>
                  Sub-categories :
                </Typography>
                {!!cat.subCat && cat.subCat.length > 0 ? (
                  <Table className={classes.table} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Sequence</TableCell>
                        <TableCell>Icon</TableCell>
                        <TableCell>Status</TableCell>
                        {EDIT_ACCESS &&
                          <TableCell>Actions</TableCell>
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cat.subCat
                        .sort((a, b) => a.seq > b.seq)
                        .map(item => {
                          return (
                            <TableRow key={item.id}>
                              <TableCell>{item.name}</TableCell>
                              <TableCell>{item.seq}</TableCell>
                              <TableCell>{item.icon}</TableCell>
                              <TableCell>
                                <StatusChip status={item.status} />
                              </TableCell>
                              {EDIT_ACCESS &&
                                <TableCell style={{ paddingLeft: "0px" }}>
                                  {item.id !== 1 && (
                                    <Box display="flex" flexWrap="no-wrap">
                                      <IconButton
                                        className={classes.button}
                                        aria-label="edit-correction"
                                        onClick={() =>
                                          editSubcatButtonClick(item)
                                        }
                                        size="small"
                                      >
                                        <EditIcon />
                                      </IconButton>
                                      {DELETE_ACCESS &&
                                        <IconButton
                                          className={classes.button}
                                          aria-label="delete-correction"
                                          onClick={() =>
                                            deleteSubcatButtonClick(item)
                                          }
                                          size="small"
                                        >
                                          <DeleteIcon />
                                        </IconButton>}
                                    </Box>
                                  )}
                                </TableCell>}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                ) : (
                  <Box justifyContent="center" display="flex">
                    No Sub-categories !!
                  </Box>
                )}
                {EDIT_ACCESS &&
                  <Fragment>
                    {cat.id !== 1 && (
                      <Box
                        justifyContent="center"
                        display="flex"
                        style={{ marginTop: "15px" }}
                      >
                        <Fab
                          size="small"
                          color="primary"
                          aria-label="add"
                          onClick={() => addSubcatButtonClick(cat.id)}
                        >
                          <AddIcon />
                        </Fab>
                      </Box>
                    )}
                  </Fragment>}
              </Paper>
            </AccordionDetails>
          </Accordion>
        );
      })}
      {EDIT_ACCESS &&
        <Fragment>
          <Box
            justifyContent="center"
            display={isLoading ? "none" : "flex"}
            style={{ marginTop: "15px" }}
          >
            <Fab
              size="small"
              color="primary"
              aria-label="add"
              onClick={addButtonClick}
            >
              <AddIcon />
            </Fab>
          </Box>

          <AddEditCatForm
            action={addEditParams.action}
            openModal={openCatModal}
            handleCloseModal={handleCloseCatModal}
            initialValues={addEditParams.initialValues}
            catId={addEditParams.catId}
            categoryList={categoryList}
          />
          <AddEditSubCatForm
            action={addEditParamsSub.action}
            openModal={openSubCatModal}
            handleCloseModal={handleCloseSubCatModal}
            initialValues={addEditParamsSub.initialValues}
            catId={addEditParamsSub.catId}
            subCatId={addEditParamsSub.subCatId}
            categoryList={categoryList}
          />
        </Fragment>}
      {DELETE_ACCESS &&
        <Fragment>
          <DeleteCatForm
            openModal={openCatDeleteModal}
            handleCloseModal={handleCloseCatDeleteModal}
            catId={deleteParams.catId}
            catName={deleteParams.catName}
            categoryList={categoryList}
          />
          <DeleteSubCatForm
            openModal={openSubCatDeleteModal}
            handleCloseModal={handleCloseSubCatDeleteModal}
            catId={deleteParamsSub.catId}
            subCatId={deleteParamsSub.subCatId}
            subCatName={deleteParamsSub.subCatName}
            categoryList={categoryList}
          />
        </Fragment>}
    </Container>
  );
}
